import { Component, ElementRef, OnInit } from '@angular/core';
import { registerScreen } from '@onviobr/profile-screen';

@Component({
	selector: 'app-notification-wrapper',
	templateUrl: './notification-wrapper.component.html',
	styleUrls: ['./notification-wrapper.component.scss'],
})
export class NotificationWrapperComponent implements OnInit {

    /**
     * Used to register the bm-profile-screen Polymer component.
     */
    private readonly registerScreen = registerScreen;

    constructor(private elRef: ElementRef) {
    	this.registerScreen();
    }

    public ngOnInit(): void {
    	const mfeNode = this.elRef.nativeElement.querySelector('mfe-loader');
    	mfeNode.preventUnmount = true;
    }
}
